import Head from "next/head";
import React, { ReactElement } from "react";
import { useRouter } from "next/router";
interface Props {
    description?: string;
    title?: string;
    keyWords?: string;
    image?: string;
    url?: string;
    type?: string;
    noIndex?: boolean;
}
const domainName = process.env.NEXT_PUBLIC_SEVERAL_BRANDS_X_DOMAIN;
export default function MetaTags(props: Props): ReactElement {
    const {
        title,
        description,
        image,
        keyWords,
        url,
        type,
        noIndex = false,
    } = props;
    const query = useRouter();
    return (
        <Head>
            <title>{title ?? domainName}</title>
            <link
                rel="canonical"
                href={`https://${domainName as string}${
                    url
                        ? url.replace("index", "")
                        : query.asPath.replace("index", "")
                }`}
            />
            <meta name="title" content={title ?? domainName} />
            <meta name="description" content={description ?? domainName} />
            <meta name="keywords" content={keyWords ?? domainName} />
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1, shrink-to-fit=no"
            />
            <meta httpEquiv="x-ua-compatible" content="ie=edge" />
            <meta name="MobileOptimized" content="width" />
            <meta name="HandheldFriendly" content="true" />
            <meta name="referrer" content="origin" />
            {noIndex && <meta name="Robots" content="noindex,nofollow" />}
            <meta
                name="rights"
                content={`©${new Date().getFullYear()} SeveralBrands.com. All rights reserved.`}
            />
            <meta itemProp="name" content={title ?? domainName} />
            <meta itemProp="description" content={description ?? domainName} />
            <meta itemProp="image" content={image ?? ""} />

            <meta property="og:type" content={type ?? "website"} />
            <meta property="og:title" content={title ?? domainName} />
            <meta
                property="og:url"
                content={`https://${domainName as string}${
                    url ? url : query.asPath
                }`}
            />
            <meta property="og:description" content={description ?? ""} />
            <meta property="og:image" content={image ?? ""} />
            <meta property="og:image:url" content={image ?? ""} />
            <meta property="og:site_name" content="SeveralBrands.com" />
            <meta property="og:locale" content="en" />

            <meta property="twitter:card" content="summary_large_image" />
            <meta
                property="twitter:url"
                content={`https://${domainName as string}${
                    url ? url : query.asPath
                }`}
            />
            <meta property="twitter:title" content={title ?? domainName} />
            <meta
                property="twitter:description"
                content={description ?? domainName}
            />
            <meta property="twitter:image" content={image ?? ""} />
        </Head>
    );
}
